<template>
  <v-content class="candidate opportunities page">
    <v-layout justify-start column fill-height>
      <div style="position: sticky; top: 0px; z-index: 2; background: #FAFAFA;">
        <v-divider />
        <v-toolbar flat color="transparent">
          <v-layout justify-end align-center row fill-height>
            <v-btn
              @click="filters.matchesOnly = !filters.matchesOnly"
              :color="themes.candidate.light.chip"
              :outline="!filters.matchesOnly"
              round
              small
            >
              Matches
            </v-btn>
            <v-spacer />
            <div style="padding-top: 20px;">
              <v-switch v-model="showMap" :color="themes.candidate.light.input" label="Show map" />
            </div>
          </v-layout>
        </v-toolbar>
        <v-divider />
      </div>
      <v-layout justify-start row wrap fill-height>
        <v-flex xs12 :md6="showMap" v-show="showList">
          <div class="overflow-wrapper">
            <div class="overflow-wrapper__inner">
              <OpportunitiesList cache @apply="openDialogFor" />
            </div>
          </div>
        </v-flex>
        <v-flex xs12 md6 v-show="showMap">
          <OpportunitiesMap
            @update:bounds="filters.bounds = $event"
            @update:center="geoCenter = $event"
            @apply="openDialogFor"
          />
        </v-flex>
      </v-layout>
    </v-layout>

    <ApplicationFormDialog v-model="showDialog" :opportunity="applicableOpportunity" />
  </v-content>
</template>

<script>
// Components
import ApplicationFormDialog from '@/components/candidate/applications/ApplicationFormDialog'
import OpportunitiesList from '@/components/candidate/opportunities/OpportunitiesList'
import OpportunitiesMap from '@/components/candidate/opportunities/OpportunitiesMap'

// Mixins
import { managedQueryParameters } from '@/mixins/managedQueryParameters.js'
import { opportunityLocationsWatchers } from '@/mixins/opportunityLocationsWatchers.js'

export default {
  mixins: [managedQueryParameters, opportunityLocationsWatchers],

  components: { ApplicationFormDialog, OpportunitiesMap, OpportunitiesList },

  created() {
    this.$store.dispatch('candidate/applications/fetchAll')
  },

  destroyed() {
    this.$router.replace({ query: null })
  },

  data() {
    return {
      showMap: true,
      showDialog: false,
      applicableOpportunity: {},
    }
  },

  computed: {
    showList() {
      return !this.showMap || this.$vuetify.breakpoint.mdAndUp
    },
  },

  watch: {
    showMap: function(showMap) {
      this.updateQueryParameters({ showMap }, false)
    },
    showDialog: function(showDialog) {
      if (!showDialog) this.applicableOpportunity = {}
    },
  },

  methods: {
    openDialogFor(opportunity) {
      this.showDialog = true
      this.applicableOpportunity = opportunity
    },
  },
}
</script>

<style lang="scss">
.candidate.opportunities.page {
  .overflow-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: scroll;

    .overflow-wrapper__inner {
      position: absolute;
      width: 100%;
      top: 0;
      bottom: 0;
    }
  }

  .v-window__container {
    height: 100%;
  }

  .v-input--selection-controls__input {
    order: 1;
    margin-right: 0px;
    margin-left: 8px;
  }
}
</style>
